







import { Component, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import { ActionsKeys } from '@/store/types';
import AzureAuth from '@/plugins/AzureAuth';

@Component({})
export default class LogoutSidebar extends Vue {
  @Action(ActionsKeys.LOGOUT) logout!: (payload?: unknown) => void;
  @Action(ActionsKeys.ROLE_CHANGING) roleChanging!: () => void;

  async doLogout() {
    this.logout();
    await AzureAuth.logout();
  }
}
